import { UserRole } from '@streamr/tv-engine';
import { create } from 'zustand';
import { UserStore } from '../../engine/streamrapp/UserStore';
export { UserRole };
const EMPTY_MESSAGES = [];
export var AcceptedParticipantType;
(function (AcceptedParticipantType) {
    AcceptedParticipantType[AcceptedParticipantType["NONE"] = 0] = "NONE";
    AcceptedParticipantType[AcceptedParticipantType["SPEAKERS"] = 1] = "SPEAKERS";
    AcceptedParticipantType[AcceptedParticipantType["GUESTS"] = 2] = "GUESTS";
})(AcceptedParticipantType || (AcceptedParticipantType = {}));
const storedDisplayName = new UserStore().getDisplayName() ?? '';
const useUserOutput = create(() => ({
    userRole: UserRole.VIEWER,
    incomingRequests: [],
    outgoingRequests: [],
    privateChatMessages: {},
    speakers: [],
    guests: [],
    cameras: [],
    localDisplayName: storedDisplayName,
    displayNames: {},
    acceptedParticipantType: AcceptedParticipantType.NONE,
}));
const reactiveOutput = {
    useUserRole: () => {
        return useUserOutput((state) => state.userRole);
    },
    useIncomingRequests: () => {
        return useUserOutput((state) => state.incomingRequests);
    },
    useOutgoingRequests: () => {
        return useUserOutput((state) => state.outgoingRequests);
    },
    usePrivateChatMessages: () => {
        return useUserOutput((state) => state.privateChatMessages);
    },
    usePrivateChatMessagesFromUser: (userId) => {
        return useUserOutput((state) => state.privateChatMessages[userId] ?? EMPTY_MESSAGES);
    },
    useSpeakers: () => {
        return useUserOutput((state) => state.speakers);
    },
    useGuests: () => {
        return useUserOutput((state) => state.guests);
    },
    useCameras: () => {
        return useUserOutput((state) => state.cameras);
    },
    useAcceptedParticipantType: () => {
        return useUserOutput((state) => state.acceptedParticipantType);
    },
    useLocalDisplayName: () => {
        return useUserOutput((state) => state.localDisplayName);
    },
    useDisplayNames: () => {
        return useUserOutput((state) => state.displayNames);
    },
};
export class UserServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setUserRole(userRole) {
        useUserOutput.setState({ userRole });
    }
    setIncomingRequests(incomingRequests) {
        useUserOutput.setState({ incomingRequests });
    }
    setOutgoingRequests(outgoingRequests) {
        useUserOutput.setState({ outgoingRequests });
    }
    addPrivateChatMessage(chatMessage) {
        useUserOutput.setState((state) => {
            const senderId = chatMessage.senderId;
            const existingMessages = state.privateChatMessages[senderId] || [];
            return {
                privateChatMessages: {
                    ...state.privateChatMessages,
                    [senderId]: [...existingMessages, chatMessage],
                },
            };
        });
    }
    setSpeakers(speakers) {
        useUserOutput.setState({ speakers });
    }
    setGuests(guests) {
        useUserOutput.setState({ guests });
    }
    setCameras(cameras) {
        useUserOutput.setState({ cameras });
    }
    setAcceptedParticipantType(acceptedParticipantType) {
        useUserOutput.setState({ acceptedParticipantType });
    }
    static getAcceptedParticipantType() {
        return useUserOutput.getState().acceptedParticipantType;
    }
    setLocalDisplayName(localDisplayName) {
        useUserOutput.setState({ localDisplayName });
    }
    setDisplayNames(displayNames) {
        useUserOutput.setState({ displayNames });
    }
}
